import React, { useEffect, useRef, useState } from 'react';
import * as cls from './results-and-case-studies.module.css';

import { Section } from '../../../ui/components/section';
import { Typography } from '../../../ui/components/typography';

export const ResultsAndCaseStudies = () => {
  const gridRef = useRef(null);
  const sectionRef = useRef(null);
  const [activeItemIndex, setActiveItemIndex] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;

      const sectionRect = sectionRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const viewportWidth = window.innerWidth;

      if (sectionRect.bottom < 0 || sectionRect.top > viewportHeight) {
        setActiveItemIndex(null);
        return;
      }

      const totalItems = 6;
      const sectionTop = sectionRect.top;
      let activeIndex = 0;
      const activationPoint =
        viewportHeight * (viewportWidth < 600 ? 0.5 : 0.75);

      if (sectionTop <= activationPoint) {
        const sectionPassedCenter = Math.max(0, activationPoint - sectionTop);
        const totalActivationDistance = viewportHeight;

        const progress = Math.min(
          sectionPassedCenter / totalActivationDistance,
          1,
        );
        activeIndex = Math.floor(progress * totalItems);

        if (progress >= 1) activeIndex = totalItems - 1;
      }

      setActiveItemIndex(activeIndex);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div ref={sectionRef}>
      <Section>
        <Typography tag="h2">Results & Case Studies</Typography>
        <div ref={gridRef} className={cls.grid}>
          <div
            className={`${cls.item} ${activeItemIndex === 0 ? cls.animated : ''}`}
          >
            <Typography
              as="h1"
              className={`${cls['item--bigger-font']} ${cls['item--color-grey']}`}
            >
              350K
            </Typography>
            <Typography style={{ display: 'inline-block' }}>
              <b>total users</b> across Europe
              <span className={cls.bar}></span>
            </Typography>
          </div>

          <div
            className={`${cls.item} ${activeItemIndex === 1 ? cls.animated : ''}`}
          >
            <Typography
              as="h1"
              className={`${cls['item--bigger-font']} ${cls['item--color-grey']}`}
            >
              70%
            </Typography>
            <Typography>
              <b>MAU</b>
            </Typography>
            <span className={cls.bar}></span>
          </div>

          <div
            className={`${cls.item} ${activeItemIndex === 2 ? cls.animated : ''}`}
          >
            <Typography
              as="h1"
              className={`${cls['item--bigger-font']} ${cls['item--color-grey']}`}
            >
              8/10
            </Typography>
            <Typography style={{ display: 'inline-block' }}>
              <b>Satisfaction</b> rating
              <span className={cls.bar}></span>
            </Typography>
          </div>

          <div
            className={`${cls.item} ${activeItemIndex === 3 ? cls.animated : ''}`}
          >
            <Typography as="h1" className={cls['item--color-grey']}>
              Engagement
              <br />
              per User
            </Typography>
            <Typography style={{ display: 'inline-block' }}>
              <b>1.47</b> min/day, <b>10.29</b> min/week, <b>41.16</b> min/month
              <span className={cls.bar}></span>
            </Typography>
          </div>

          <div
            className={`${cls.item} ${activeItemIndex === 4 ? cls.animated : ''}`}
          >
            <Typography as="h1" className={cls['item--color-grey']}>
              Visit
              <br />
              Frequency
            </Typography>
            <Typography style={{ display: 'inline-block', maxWidth: 210 }}>
              <b>4.5</b> sessions/week, <b>17</b> sessions/month
              <span className={cls.bar}></span>
            </Typography>
          </div>

          <div
            className={`${cls.item} ${activeItemIndex === 5 ? cls.animated : ''}`}
          >
            <Typography as="h1" className={cls['item--color-grey']}>
              Top
              <br />
              Countries
            </Typography>
            <Typography style={{ display: 'inline-block' }}>
              UK, Italy, Greece, France, Spain, Austria
              <span className={cls.bar}></span>
            </Typography>
          </div>
        </div>
      </Section>
    </div>
  );
};
